import { Lang } from 'Roblox';
import angular from 'angular';

const catalog = angular
  .module('catalog', ['robloxApp', 'cursorPagination', 'infiniteScroll', 'thumbnails'])
  .config([
    '$locationProvider',
    'languageResourceProvider',
    ($locationProvider, languageResourceProvider) => {
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
      });

      languageResourceProvider.setLanguageKeysFromFile(Lang.CatalogResources);
    }
  ]);

export default catalog;
